import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { ModalBase } from '../ModalBase/ModalBase.js';

const OverlayWithHeader = /*#__PURE__*/React.forwardRef(function OverlayWithHeader({
  children,
  isOpen,
  onDismiss,
  ...rest
}, ref) {
  return jsx(ModalBase, {
    overlayClassName: "top-2xl bg-white",
    contentClassName: "w-full h-full",
    isOpen: isOpen,
    onDismiss: onDismiss,
    ref: ref,
    ...rest,
    children: children
  });
});

export { OverlayWithHeader };
